"use strict";
// Copyright (C) 2017-2026 Smart code 203358507
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var SubtitleVariant_1 = __importDefault(require("./SubtitleVariant"));
exports.default = SubtitleVariant_1.default;
